import Vue from 'vue'
import VueRouter from 'vue-router'
import { systemRoutes } from 'core/router/index'
// import availability from '../views/availability/availability.vue'
import terms from '../views/terms/terms.vue'
import shop from '../views/shop/shop.vue'
import flightresults from '../views/flightresults'

Vue.use(VueRouter)

const routes = systemRoutes.concat([
  {
    path: '/',
    name: 'availability',
    component: flightresults,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/terms-and-conditions',
    name: 'terms',
    component: terms,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/shop',
    name: 'shop',
    component: shop
  }
])

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_MODULE_PREFIX,
  routes
})

export default router
